import { Container, Headings, Text } from '@foradevelopment/fora-ui';
import { PayMonthOverviewViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { getReadableMonthAndYearFromPayMonth } from '@fora-monorepo/employer-my-pages-common/utils';
import { swedishNumberFormatter } from '@fora-monorepo/string-utils';

import { useAppSelector } from '../../redux/hooks';
import { useTypedTranslation } from '../../i18n/i18n';

export const ReportSummary = ({ selectedReportingPeriod }: { selectedReportingPeriod: PayMonthOverviewViewModel }) => {
  const { t } = useTypedTranslation();

  const { numberOfNewEntries, totalPayAmountInNewEntries, numberOfChangedEntries } = useAppSelector(
    state => state.payroll.payAmountSummaryData
  );

  return (
    selectedReportingPeriod && (
      <>
        <Headings.H3 marginBottom={16}>{t('panel.reviewAndConfirm.title')}</Headings.H3>
        <Container key={selectedReportingPeriod.payMonth}>
          <Headings.H5>{getReadableMonthAndYearFromPayMonth(selectedReportingPeriod.payMonth)}</Headings.H5>
          <Container marginBottom={16}>
            {numberOfNewEntries > 0 && (
              <Text>
                {t('panel.reviewAndConfirm.monthlyTotal', {
                  totalPayrolls: numberOfNewEntries,
                  totalPayAmount: swedishNumberFormatter(totalPayAmountInNewEntries),
                })}
              </Text>
            )}
            {numberOfChangedEntries > 0 && (
              <Text>
                {t('panel.reviewAndConfirm.changedEntries', {
                  numberOfChangedEntries,
                })}
              </Text>
            )}
          </Container>
        </Container>
      </>
    )
  );
};
